goog.provide('el8.util.amplitude.billingHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Log that the user clicked the 'Open Billing System' link from the billing report
 *
 */
el8.util.amplitude.logOpenBillingSystem = function () {
    el8.util.amplitude.logEvent('Access Billing System', { source: 'Billing Report'});
};
